import React, { RefObject } from 'react';
import Button from '../../../../../components/Common/Button';
import Logo from '../../../../Admin/logo.webp';
import { BookModel } from '../../../../../interfaces/book.interface';

interface BackCoverSectionProps {
  bookData: BookModel;
  setSummaryModal: (value: boolean) => void;
  targetRefs: RefObject<any>;
}

const BackCoverSection: React.FC<BackCoverSectionProps> = ({
                                                             bookData,
                                                             setSummaryModal,
                                                             targetRefs
                                                           }) => {
  return (
    <div
      className="w-full h-full flex flex-col gap-4  md:flex md:flex-row md:justify-center md:gap-4 p-0 md:p-2 rounded  xs:flex-wrap">
      <div className="md:flex md:justify-center py-2 gap-4 xs:flex-wrap h-full">
        {/* Last cover Black Page (no action button — intentionally blank) */}
        <div className="flex flex-col items-center h-full">
          <div
            className="mb-4 md:mb-0 h-72 w-72 rounded-lg mx-auto relative"
            style={{
              backgroundImage: `url("/pattern.png")`,
              backgroundSize: 'cover'
            }}
          ></div>
        </div>
        {/* Back Cover last Blank Page */}
        <div
          className="flex flex-col items-center h-full"
          id="edit-summary"
          key="edit-summary"
          ref={(ref) => (targetRefs.current['edit-summary'] = ref) as any}
        >
          <div
            className="flex flex-col justify-between mx-auto h-72 w-72 py-4 px-5 items-center rounded font-serif"
            style={{
              backgroundImage: `url("/texture.png")`,
              backgroundSize: 'cover'
            }}
          >
            <div className="flex flex-col items-center gap-6">
              <h3 className="text-lg bold font-yuji-boku text-center">{bookData?.title}</h3>
              <h3 className="text-[10px]  font-poppins text-black text-justify">
                {bookData?.summary?.length! > 300
                  ? bookData?.summary?.slice(0, 300) + '...'
                  : bookData?.summary}
              </h3>
            </div>
            <div className="w-full flex justify-end items-center gap-3">
              <div className="flex items-baseline gap-1">
                <img className="h-3 md:h-6 w-auto" src={Logo} alt="Build My Story" />
              </div>
              <div>
                <div className="flex flex-col gap-1">
                  <h3 className="text-[8px]">www.buildmystory.com</h3>
                </div>
              </div>
            </div>
          </div>
          {/*
            Same wrapper shape as the standard page tile action area
            (StoryPages.tsx ImageActions): mt-auto pushes the button to
            the bottom of the column; pt-4/pb-4 give the same 1rem
            top/bottom margin as Edit Text and Edit scene. This keeps
            "Edit Summary" aligned horizontally with the buttons in the
            previous columns of the same row.
          */}
          <div className="mt-auto pt-4 pb-4 flex items-center justify-center">
            <Button
              title="Edit Summary"
              onClick={() => {
                setSummaryModal(true);
              }}
              className="bg-storyblueSecondLightText flex text-white font-sans rounded-2xl px-4 py-2 text-xs h-8 w-[120px] justify-center"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackCoverSection;
